import * as React from 'react'
import LazyLoad, { LazyLoadProps } from 'react-lazyload'

interface IProps extends LazyLoadProps {
  disabled?: boolean
}

const EnhancedLazyLoad = ({ disabled, children, ...rest }: IProps) => {
  if (disabled || !children) {
    return children ? children : null
  }

  return <LazyLoad {...rest}>{children}</LazyLoad>
}

export default EnhancedLazyLoad
